const log = (...data) => {
    console.log(data)
}

const info = (...data) => {
    console.info(data)
}

const warn = (...data) => {
    console.warn(data)
}

const error = (...data) => {
    console.error(data)
}


export default {
    log,
    info,
    warn,
    error

}